var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";
import { IconWrapper } from "./Icon.styled";
import { ArmchairDollar, Car, Cows, FastForwardCircle, Irrigation, Money, PhotovoltaicsSun, TickCircle, ArrowDownSquare, CarShield, CowsShield, GiftDollar, Lands, MoneyPlus, PlantGrowth, TickRounded, ArrowUpSquare, Cash, Crops, GlobeHands, LandsArrowsUp, NaturalDisaster, PlantationSnowflake, TickSharp, ArrowsDirections, CheckboxArrow, CropsMoney, HandBulb, LaptopAccount, PaperBookmark, Play, TodoListHand, Banknote, ChevronDown, CropsShield, HandCoins, Like, PaperBookmarkLock, Search, Tractor, BarnPlus, ChevronRight, CurvedArrow, HandGrid, LinkedIn, PaperBulb, SearchBulb, TractorShield, Bulb, Chickens, Distributor, HandPercentDown, Mail, PaperShield, Shield, Tweet, Calendar, ChickensShield, Doc, HandsParallel, MapMarker, Pdf, ShieldPlantGrowth, Umbrella, CalendarFlower, ClockDollar, Emission, HeartEcg, MessagesBulb, People, Signposts, Wrench, CalendarLeaf, ClockRoundArrow, Facebook, HeartEcgShield, MessagesEllipsis, Percent, SimpleHouse, CallcenterHeadset, CloseX, Farm, House, Messenger, Phone, SquaresOverlapping, CallcenterPerson, Cow, FarmShield, Info, Mobile, PhotovoltaicsShield, Star, X2, LikeIcon } from "../Icons";
export var iconMap = {
  ArmchairDollar: ArmchairDollar,
  ArrowDownSquare: ArrowDownSquare,
  ArrowsDirections: ArrowsDirections,
  ArrowUpSquare: ArrowUpSquare,
  Banknote: Banknote,
  BarnPlus: BarnPlus,
  Bulb: Bulb,
  Calendar: Calendar,
  CalendarFlower: CalendarFlower,
  CalendarLeaf: CalendarLeaf,
  CallcenterHeadset: CallcenterHeadset,
  CallcenterPerson: CallcenterPerson,
  Car: Car,
  CarShield: CarShield,
  Cash: Cash,
  CheckboxArrow: CheckboxArrow,
  ChevronDown: ChevronDown,
  ChevronRight: ChevronRight,
  Chickens: Chickens,
  ChickensShield: ChickensShield,
  ClockDollar: ClockDollar,
  ClockRoundArrow: ClockRoundArrow,
  CloseX: CloseX,
  Cow: Cow,
  Cows: Cows,
  CowsShield: CowsShield,
  Crops: Crops,
  CropsMoney: CropsMoney,
  CropsShield: CropsShield,
  CurvedArrow: CurvedArrow,
  Distributor: Distributor,
  Doc: Doc,
  Emission: Emission,
  Facebook: Facebook,
  Farm: Farm,
  FarmShield: FarmShield,
  FastForwardCircle: FastForwardCircle,
  GiftDollar: GiftDollar,
  GlobeHands: GlobeHands,
  HandBulb: HandBulb,
  HandCoins: HandCoins,
  HandGrid: HandGrid,
  HandPercentDown: HandPercentDown,
  HandsParallel: HandsParallel,
  HeartEcg: HeartEcg,
  HeartEcgShield: HeartEcgShield,
  House: House,
  Info: Info,
  Irrigation: Irrigation,
  Lands: Lands,
  LandsArrowsUp: LandsArrowsUp,
  LaptopAccount: LaptopAccount,
  Like: Like,
  LinkedIn: LinkedIn,
  Mail: Mail,
  MapMarker: MapMarker,
  MessagesBulb: MessagesBulb,
  MessagesEllipsis: MessagesEllipsis,
  Messenger: Messenger,
  Mobile: Mobile,
  Money: Money,
  MoneyPlus: MoneyPlus,
  NaturalDisaster: NaturalDisaster,
  PaperBookmark: PaperBookmark,
  PaperBookmarkLock: PaperBookmarkLock,
  PaperBulb: PaperBulb,
  PaperShield: PaperShield,
  Pdf: Pdf,
  People: People,
  Percent: Percent,
  Phone: Phone,
  PhotovoltaicsShield: PhotovoltaicsShield,
  PhotovoltaicsSun: PhotovoltaicsSun,
  PlantationSnowflake: PlantationSnowflake,
  PlantGrowth: PlantGrowth,
  Play: Play,
  Search: Search,
  SearchBulb: SearchBulb,
  Shield: Shield,
  ShieldPlantGrowth: ShieldPlantGrowth,
  Signposts: Signposts,
  SimpleHouse: SimpleHouse,
  SquaresOverlapping: SquaresOverlapping,
  Star: Star,
  TickCircle: TickCircle,
  TickRounded: TickRounded,
  TickSharp: TickSharp,
  TodoListHand: TodoListHand,
  Tractor: Tractor,
  TractorShield: TractorShield,
  Tweet: Tweet,
  Umbrella: Umbrella,
  Wrench: Wrench,
  X2: X2,
  LikeIcon: LikeIcon
};

var Icon = function Icon(props) {
  var Icon = iconMap[props.name];
  return React.createElement(IconWrapper, __assign({}, props), Icon && React.createElement(Icon, null));
};

export default Icon;